(function () {
    "use strict";
    angular.module("app").component("detailHeaderCompany", {
        templateUrl: "@/detailHeader/detail-header-company.html",
        bindings: {
            request: "=",
            assignedTo: "=",
            index: "=",
        },
        controller: DetailHeaderCompanyController
    });

    DetailHeaderCompanyController.$inject = ["enumService", "HabilNavigator", "fvmRequestHelper"];
    function DetailHeaderCompanyController(enumService, HabilNavigator, fvmRequestHelper) {
        const $controller = Object.assign(this, {
            GetLabel,
            GetIcon,
            GetStyle,
            OpenDossier
        });

        const dossierStatusCodes = enumService.DossierStatusCodes;

        function GetLabel() {
            return fvmRequestHelper.GetInitialActionText($controller.request);
        }

        function GetIcon() {
            return fvmRequestHelper.GetInitialActionIcon($controller.request);
        }

        function GetStyle() {
            if (!$controller.request || !$controller.request.DossierInfo)
                return "";

            if ($controller.request.Deleted || Number.parseInt($controller.request.DossierInfo.StatusCode, 10) == dossierStatusCodes.Blocked) {
                return "alert alert-danger";
            }
        }

        function OpenDossier() {
            HabilNavigator.OpenDossierOrganisation($controller.request.DossierPublicId);
        }
    }
})();